<div class="progress-outer">
  <div class="progress-inner" [style.width]="progress + '%'">
    {{progress}}%
  </div>
</div>